import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { SUBSCRIPTION_TYPES } from 'common/constants/subscription'

import { getFormattedProductName } from 'utils/subscription'

const convertConstraints = arr => Object.fromEntries(arr.map(datum => [datum.featureProduct.featureType, datum]))

const createNewConstraint = ({
    projectId = null,
    productName = null,
    nextRenewalDate = null,
    constraints = {},
} = {}) => ({
    projectId,
    productName,
    nextRenewalDate,
    constraints,
})

const useUserSubscriptions = (subscriptionIdForConstraints = null) => {
    const { user_subscriptions, organizations } = useSelector(state => state)
    const [basicConstraints, setBasicConstraints] = useState(() => createNewConstraint())
    const [oneProjectConstraintsArray, setOneProjectConstraintsArray] = useState([])

    useEffect(() => {
        if (!user_subscriptions) {
            setOneProjectConstraintsArray([])
            return
        }
        const oneProjectSubscriptions = user_subscriptions.filter(
            subscription => subscription.type === SUBSCRIPTION_TYPES.PROJECT && !subscription.expired,
        )
        setOneProjectConstraintsArray(
            oneProjectSubscriptions.map(subscription =>
                createNewConstraint({
                    projectId: subscription.projectId,
                    productName: getFormattedProductName(subscription.product.name),
                    nextRenewalDate: subscription.constraintNextRenewalDate,
                    constraints: convertConstraints(subscription.constraints),
                }),
            ),
        )
    }, [user_subscriptions])

    useEffect(() => {
        if (subscriptionIdForConstraints) {
            const subscription = user_subscriptions.find(sub => sub.id === subscriptionIdForConstraints)
            if (!!subscription && !subscription.expired) {
                setBasicConstraints(
                    createNewConstraint({
                        projectId: subscription.projectId,
                        productName: getFormattedProductName(subscription.product.name),
                        nextRenewalDate: subscription.constraintNextRenewalDate,
                        constraints: convertConstraints(subscription.constraints),
                    }),
                )
                return
            }
        }

        const selectedSubscription = organizations.selectedSubscription
        if (!selectedSubscription?.constraints) return

        setBasicConstraints(
            createNewConstraint({
                productName: getFormattedProductName(selectedSubscription.product.name),
                nextRenewalDate: selectedSubscription.expired ? null : selectedSubscription.constraintNextRenewalDate,
                constraints: convertConstraints(selectedSubscription.constraints),
            }),
        )
    }, [organizations.selectedSubscription, subscriptionIdForConstraints])

    return { subscriptions: user_subscriptions, basicConstraints, oneProjectConstraintsArray }
}

export default useUserSubscriptions
